import React, { useState, useEffect,useRef,useMemo } from 'react';

import { motion,useAnimation, useInView , AnimatePresence , useScroll, useTransform} from 'framer-motion';
import { Users2, MessageSquare, Wallet, Rocket, Target ,ChevronRight, ChevronDown, Database, MemoryStickIcon as MemoryIcon ,GripVertical} from 'lucide-react'
import m_2 from '../../assets/images/Untitled design (14).png'
import u_2 from '../../assets/images/AI100E(U.2).png'
import llama2 from '../../assets/images/image.jpeg'
import miphi from '../../assets/images/miphi_black.png'
import medic from '../../assets/images/medic.jpg'
import micromax from '../../assets/images/Micromax-logo.png'
import phison from '../../assets/images/Phison White Logo - 200.png'
import aiDAPTIV from '../../assets/images/Copy of 512 GB - 2 TB-cropped.svg'

import {Link} from 'react-router-dom'
const Cpu = ({ className, ...props }) => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
  >
      <rect x={4} y={4} width={16} height={16} rx={2} ry={2} />
      <rect x={9} y={9} width={6} height={6} rx={2} ry={2} />
  </svg>
);
const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  
 
 
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  }

  const staggerChildren = {
    animate: {
      transition: {
        staggerChildren: 0.2
      }
    }
  }

  const imageAnimation = {
    initial: { opacity: 0, scale: 0.95 },
    animate: { 
      opacity: 1, 
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  }
  const controls = useAnimation()

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      controls.start({ y: scrollY * 0.1 }) // Smooth parallax effect
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [controls])
  const containerRef = useRef(null)
  const isInView = useInView(containerRef, { once: true })
  
  const cards = [
    {
      icon: Users2,
      title: "Our focus is you",
      description: "We dedicate ourselves entirely to your project and business. As founders, we're directly involved in every aspect of the project, ensuring clear understanding and accurate implementation from concept to delivery."
    },
    {
      icon: MessageSquare,
      title: "Collaborative Edge",
      description: "Our approach offers a truly collaborative experience with dedicated Slack channels, regular demos, catch-up meetings, transparent project roadmaps, constant communication, onsite visits, and transparent project management workflows."
    },
    {
      icon: Wallet,
      title: "Unmatched Value",
      description: "We offer significant cost savings compared to other agencies and in-house hires, with flexible engagements ideal for varying workloads. Choose a partnership that delivers exceptional value without compromising on quality."
    },
    {
      icon: Rocket,
      title: "Innovation First",
      description: "We leverage cutting-edge technologies and methodologies to deliver innovative solutions that keep you ahead of the competition."
    },
    {
      icon: Target,
      title: "Results Driven",
      description: "Our focus is on delivering measurable results that align with your business objectives and drive real value for your organization."
    }
  ]
  const testimonials = [
    {
      quote: "Harry and Reece were professional, practical and responsive during the entirety of the project, which included planning, development and QA. I especially liked their candidness, promptness, and their focus on collaboration.",
      author: "Alex",
      role: "Owner of scale",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "Having reviewed and spoken to many agencies, Forward Digital just understood our PRD right from the outset. They gave us a very useful amount of insight into how exactly they could engineer the end product, and gave us confidence from start to finish that they were really the right folks for this job. They delivered incredibly quickly.",
      author: "Sharooz",
      role: "CEO at Wavekick",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "... Forward Digital was instrumental in getting our website on track for a major relaunch.",
      author: "Uyen",
      role: "CEO at eSwapp",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "...they've continually solved problems balancing technical knowledge with business context.",
      author: "Henry",
      role: "CEO at Staze",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "Time and again they have delivered brilliant products. They show ingenuity in problem solving, and are always willing to provide support and guidance.",
      author: "Simon",
      role: "Head of Development at 542 Digital",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "... they skilfully bring a software project from an idea to fruition. I was particularly impressed with their communication skills, attention to detail, and how they think towards the future; considering the maintainability of a project.",
      author: "Steve",
      role: "CTO at mTA",
      image: "/placeholder.svg?height=40&width=40"
    },
    {
      quote: "... Consistently delivered excellent quality code, quickly and efficiently and always going the extra mile to ensure we hit our deadlines and delivered a great product.",
      author: "Ben",
      role: "Technology Director at Native Design",
      image: "/placeholder.svg?height=40&width=40"
    }
  ]
  const numRows = 4;
  const numCols = 4;
  const totalGridCells = numRows * numCols;

  const splitImageIntoGrid = () => {
    const grid = [];
    for (let row = 0; row < numRows; row++) {
      for (let col = 0; col < numCols; col++) {
        const x = (col / numCols) * 100;
        const y = (row / numRows) * 100;
        grid.push({ x, y });
      }
    }
    return grid;
  };

  const gridCells = splitImageIntoGrid();
  return (
    
    <div className=" relative min-h-screen bg-black  pt-20">
  <section className="relative h-screen lg:h-screen 2xl:h-[100vh] 2xl:p-4 overflow-hidden">
      <motion.div className="absolute inset-0 z-0">
        <div className="grid grid-cols-4 gap-4 p-4 h-full">
          {gridCells.map((cell, i) => (
            <div
              key={i}
              className="relative group overflow-hidden rounded-2xl  backdrop-blur-sm"
            >
              <motion.div
                className="absolute inset-0 bg-cover bg-center "
                style={{
                  backgroundImage: `url(https://informationage-production.s3.amazonaws.com/uploads/2023/05/ai-identified-as-top-industry-disruptor-by-ceos-1568x1045.jpg)`,
                  backgroundPosition: `${cell.x}% ${cell.y}%`,
                  backgroundSize: `${numCols * 100}% ${numRows * 100}%`,
                }}
                initial={false}
                whileHover={{ scale: 1.1, rotate: 2 }}
                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
              />
            </div>
          ))}
        </div>
      </motion.div>

      {/* Dark Overlay - Moved between image grid and text content */}
      <motion.div className="absolute inset-0 z-10 bg-black/60" />

      <motion.div className="relative z-20 flex h-full items-center justify-center text-center">
  <div className="space-y-8 px-4">
    <h1 className="text-5xl font-bold tracking-tighter sm:text-7xl text-white">
      We want AI to be accessible to everyone!
    </h1>
    <div className="mx-auto max-w-2xl space-y-9 text-lg text-gray-300">
      <p className="text-4xl font-semibold text-gray-100">
        Authorized solution partner of
      </p>
      <img 
        src={miphi} 
        alt="MiPhi Logo" 
        className="h-20 w-auto mx-auto" 
      />
    </div>
  </div>
</motion.div>
    </section>

     <section id="next-section" className="bg-black py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div 
          className="mb-16 text-center"
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          variants={fadeIn}
        >
          <h2 className="mb-6 text-3xl font-bold text-white md:text-4xl lg:text-5xl">
            Advanced AI Memory Solutions for Next-Generation Computing
          </h2>
          <p className="mx-auto max-w-3xl text-lg text-white/70">
            At HYPER COGNITIVE, we revolutionize GPU performance with cutting-edge memory chips that accelerate AI processing and transform how industries operate in the digital age.
          </p>
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <motion.div
            className="relative aspect-square lg:aspect-auto"
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={imageAnimation}
          ><br></br>
            <img
              src={aiDAPTIV}
              alt="AI Memory Chip Technology"
              className="h-full w-full rounded-3xl object-cover"
            />
          </motion.div>

          <motion.div
            className="space-y-12"
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={staggerChildren}
          >
            <motion.div 
              className="space-y-2"
              variants={fadeIn}
            >
              <h3 className="text-xl font-semibold text-white">
                Enhanced GPU Performance:
              </h3>
              <p className="text-white/70">
                Our AI memory chips significantly boost GPU processing capabilities, enabling faster training of AI models and real-time processing of complex algorithms with reduced latency.
              </p>
            </motion.div>

            <motion.div 
              className="space-y-2"
              variants={fadeIn}
            >
              <h3 className="text-xl font-semibold text-white">
                Industry-Wide Impact:
              </h3>
              <p className="text-white/70">
                From healthcare diagnostics to financial analytics, our memory solutions accelerate innovation across sectors, enabling breakthroughs in AI-driven applications and services.
              </p>
            </motion.div>

            <motion.div 
              className="space-y-2"
              variants={fadeIn}
            >
              <h3 className="text-xl font-semibold text-white">
                Economic Growth Driver:
              </h3>
              <p className="text-white/70">
                By making advanced AI capabilities accessible to businesses of all sizes, we're fostering job creation, productivity gains, and sustainable economic development.
              </p>
            </motion.div>

            <motion.div 
              className="space-y-2"
              variants={fadeIn}
            >
              <h3 className="text-xl font-semibold text-white">
                Future-Ready Solutions:
              </h3>
              <p className="text-white/70">
                Our memory chips are designed to support emerging AI technologies, ensuring your infrastructure stays ahead of the curve in the rapidly evolving digital landscape.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
    
    <div className="min-h-screen  text-white">
    <div className="min-h-screen text-white">
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-8 md:py-16 text-center relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-3xl backdrop-blur-sm -z-10" />
        
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300">
          Transforming Ideas into Digital Reality
        </h1>
        
        <div className="max-w-3xl mx-auto space-y-4 text-gray-300">
          <p className="text-base md:text-lg">
            We're a forward-thinking development studio specializing in crafting bespoke digital solutions. 
            From enterprise-grade applications to stunning websites, we turn complex challenges into 
            elegant, user-friendly experiences.
          </p>
        </div>
      </section>

      {/* Architecture Comparison Section */}
      <section className="text-white p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Left Panel - Llama Training */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-4 md:p-6 rounded-xl shadow-lg border border-gray-700 h-full">
              <span className="font-bold text-xl md:text-2xl block text-center mb-6">Existing Architecture</span>
              
              <div className="flex justify-center mb-6">    
                <div className="relative w-24 md:w-32 h-24 md:h-32 rounded-full flex items-center justify-center">
                  <img src={llama2} alt="Llama" className="w-full h-full object-contain" />
                </div>
              </div>

              <h2 className="text-xl md:text-2xl font-bold mb-4 text-center text-white">Llama-2 70B Training</h2>
              <div className="text-emerald-200/80 mb-4 text-center font-semibold text-sm md:text-base">1.4TB memory space required</div>
              
              <div className="grid grid-cols-7 gap-1">
                {Array(49).fill().map((_, i) => (
                  <div key={i} className="bg-gray-700 h-4 md:h-6 rounded-sm flex items-center justify-center text-[10px] md:text-xs text-white">
                    Data
                  </div>
                ))}
              </div>

              <div className="mt-4 text-xs md:text-sm text-gray-400 text-center">Data cut into slices</div>
            </div>

            {/* Middle Panel - Non-aiDAPTIV */}
            <div className="relative h-full">
              <ChevronRight className="hidden lg:block absolute -left-12 top-1/2 transform -translate-y-1/2 w-8 h-8 md:w-16 md:h-16 text-white" />
              <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-4 md:p-6 rounded-xl shadow-lg border border-gray-700 h-full">
                <div className="text-center mb-6">
                  <span className="font-bold text-xl md:text-2xl">Non-aiDAPTIV+ Architecture</span>
                  <div className="text-sm text-gray-300 mt-2">Limited by GPU Memory</div>
                </div>

                <div className="text-center text-white mb-4 text-lg md:text-xl font-bold">
                  30 GPU to train Llama-2 (70B)
                </div>
                <div className="text-xs text-gray-300 mb-6 md:mb-8 text-center">
                  (Requires 8 Workstations and Network Infrastructure)
                </div>

                <div className="flex flex-col gap-4">
                  {/* First Row */}
                  <div className="grid grid-cols-2 gap-4">
                    {[1, 2].map((node) => (
                      <div key={node} className="bg-[#0A0B1E] p-3 md:p-4 rounded-lg border border-emerald-900">
                        <div className="flex justify-between items-center mb-3 md:mb-4">
                          <div>
                            <span className="text-gray-200 text-sm md:text-base">Node {node}</span>
                            <div className="text-white text-xs md:text-sm">1.4 kW</div>
                          </div>
                          <div className="p-1 md:p-2">
                            <img src="https://cdn1.iconfinder.com/data/icons/technology-and-hardware-2/200/vector_66_06-512.png" alt="GPU" className="w-6 h-6 md:w-8 md:h-8" />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-1 md:gap-2">
                          {Array(4).fill().map((_, i) => (
                            <div key={i} className="flex rounded bg-gray-800">
                              <div className="bg-emerald-600/40 w-full h-5 md:h-6 flex items-center justify-center">
                                <span className="text-[10px] md:text-xs">HBM</span>
                              </div>
                              <div className="bg-gray-700 w-full h-5 md:h-6 rounded-r flex items-center justify-center">
                                <span className="text-[10px] md:text-xs">Data</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Vertical Dots */}
                  <div className="flex justify-center py-2">
                    <GripVertical className="text-white w-6 h-6" />
                  </div>

                  {/* Second Row */}
                  <div className="grid grid-cols-2 gap-4">
                    {[7, 8].map((node) => (
                      <div key={node} className="bg-[#0A0B1E] p-3 md:p-4 rounded-lg border border-emerald-900">
                        <div className="flex justify-between items-center mb-3 md:mb-4">
                          <div>
                            <span className="text-gray-200 text-sm md:text-base">Node {node}</span>
                            <div className="text-white text-xs md:text-sm">1.4 kW</div>
                          </div>
                          <div className="p-1 md:p-2">
                            <img src="https://cdn1.iconfinder.com/data/icons/technology-and-hardware-2/200/vector_66_06-512.png" alt="GPU" className="w-6 h-6 md:w-8 md:h-8" />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-1 md:gap-2">
                          {Array(4).fill().map((_, i) => (
                            <div key={i} className="flex rounded bg-gray-800">
                              <div className="bg-emerald-600/40 w-full h-5 md:h-6 flex items-center justify-center">
                                <span className="text-[10px] md:text-xs">HBM</span>
                              </div>
                              <div className="bg-gray-700 w-full h-5 md:h-6 rounded-r flex items-center justify-center">
                                <span className="text-[10px] md:text-xs">{node === 8 && i > 1 ? "Idle" : "Data"}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="text-xs md:text-sm text-gray-400 text-center mt-4">Note: Assumes 48GB / GPU</div>
              </div>
            </div>

            {/* Right Panel - aiDAPTIV */}
            <div className="relative h-full">
              <ChevronRight className="hidden lg:block absolute -left-12 top-1/2 transform -translate-y-1/2 w-8 h-8 md:w-16 md:h-16 text-white" />
              <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-4 md:p-6 rounded-xl shadow-lg border border-gray-700 h-full">
                <div className="text-center mb-6">
                  <span className="font-bold text-xl md:text-2xl">aiDAPTIV+ Architecture</span>
                  <div className="text-sm mt-2 text-blue-200">Flexible Model Size</div>
                </div>

                <div className="text-center mb-4 text-lg md:text-xl font-bold">
                  4 GPU to train Llama-2 (70B)
                </div>
                <div className="text-xs mb-6 md:mb-8 text-center text-blue-200">
                  (Requires 1 Workstation)
                </div>

                <div className="space-y-4 md:space-y-6">
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-lg mx-auto flex items-center justify-center">
                    <img src="https://cdn1.iconfinder.com/data/icons/technology-and-hardware-2/200/vector_66_06-512.png" alt="GPU" className="w-full h-full object-contain" />
                  </div>
                  
                  <div className="grid grid-cols-4 gap-1 md:gap-2">
                    {Array(8).fill().map((_, i) => (
                      <div key={i} className="flex w-full h-5 md:h-6 rounded-sm overflow-hidden">
                        <div className="w-1/2 bg-emerald-600/40 flex items-center justify-center text-[10px] md:text-xs text-white">
                          HBM
                        </div>
                        <div className="w-1/2 bg-gray-700 flex items-center justify-center text-[10px] md:text-xs text-white">
                          Data
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="flex justify-center items-center gap-2">
                    <ChevronDown className="w-4 h-4 md:w-6 md:h-6 text-gray-600" />
                    <span className="text-xs md:text-sm font-semibold">Extend GPU Memory</span>
                    <ChevronDown className="w-4 h-4 md:w-6 md:h-6 text-gray-600" />
                  </div>

                  <div className="flex justify-center gap-4">
                    <div className="w-16 md:w-24 h-8 md:h-12 rounded-lg flex items-center justify-center">
                      <img src={m_2} alt="Memory" className="w-full h-full object-contain" />
                    </div>
                    <div className="w-10 md:w-24 h-8 md:h-12 rounded-lg flex items-center justify-center">
                      <img src={u_2} alt="USB" className="w-full h-full object-contain" />
                    </div>
                  </div>

                  <div className="grid grid-cols-4 gap-1 md:gap-2">
                    {Array(8).fill().map((_, i) => (
                      <div key={i} className="bg-gray-700 h-5 md:h-6 rounded-sm flex items-center justify-center text-[10px] md:text-xs text-white">
                        Data
                      </div>
                    ))}
                  </div>

                  <div className="text-center text-xs md:text-sm text-blue-200">PENDING SLICES</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

      {/* Portfolio Section */}
      <section className="container mx-auto px-4 py-16">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl font-bold mb-12 text-center bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-300"
        >
          Some of our MiPhi's best work
        </motion.h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Medical Case Study */}
          <motion.div 
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
            className="group cursor-pointer h-full"
          >
            <div className="bg-[#1c1f26]/40 backdrop-blur-md rounded-xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-300 shadow-lg hover:shadow-2xl h-full">
              <div className="p-8 relative w-full h-full flex items-center">
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative z-10 w-full">
                  <p className="text-gray-300 text-lg group-hover:text-white transition-colors duration-300 w-full">
                    Partnered with leading hospitals to implement AI-enhanced medical imaging systems, 
                    reducing diagnostic time by 60% and improving accuracy by 40%. Our memory chips 
                    enabled real-time processing of complex medical data, supporting faster patient 
                    diagnostics and treatment planning.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Automotive Case Study */}
          <motion.div 
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
            className="group cursor-pointer h-full"
          >
            <div className="bg-[#0a4d2c]/40 backdrop-blur-md rounded-xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-300 shadow-lg hover:shadow-2xl h-full">
              <div className="p-8 relative w-full h-full flex items-center">
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative z-10 w-full">
                  <p className="text-gray-100 text-lg group-hover:text-white transition-colors duration-300 w-full">
                    Revolutionized a major automotive manufacturer's production line with our AI memory 
                    chips, enabling real-time robotics control and quality assurance. Achieved 35% 
                    reduction in production costs while improving product quality metrics by 45%.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>


        {/* See More Link */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center mt-16"
        >
          <Link 
            to="/solutions" 
            className="relative inline-block group"
          >
            <span className="relative z-10 text-white group-hover:text-gray-200 text-lg transition-colors duration-300">
              See more of our work →
            </span>
            <div className="absolute inset-0 bg-white/5 -z-10 rounded-lg backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </Link>
        </motion.div>
      </section>
    </div>
    <div ref={containerRef} className="min-h-screen ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="min-h-screen flex flex-col lg:flex-row relative">
            {/* Static Left Side */}
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: isInView ? 1 : 0 }}
              transition={{ duration: 1 }}
              className="lg:w-1/2 lg:sticky lg:top-0 lg:h-screen flex items-center"
            >
              <div className="py-24 pr-8">
                <motion.h1 
                  initial={{ y: 20 }}
                  animate={{ y: isInView ? 0 : 20 }}
                  transition={{ duration: 1, delay: 0.2 }}
                  className="text-5xl font-bold text-white mb-6"
                >
                  Our approach
                </motion.h1>
                <motion.p 
                  initial={{ y: 20 }}
                  animate={{ y: isInView ? 0 : 20 }}
                  transition={{ duration: 1, delay: 0.4 }}
                  className="text-xl text-gray-400"
                >
                  A collaborative, trusted & cutting-edge digital approach to software development
                </motion.p>
              </div>
            </motion.div>

            {/* Scrolling Cards */}
            <div className="lg:w-1/2 min-h-screen pt-24 space-y-6">
              {cards.map((card, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 100 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="relative group"
                >
                  <div className="absolute inset-0 bg-gray-600/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300" />
                  <div className="relative bg-gray-900/40 backdrop-blur-md rounded-2xl p-8 border border-emerald-500/10 hover:border-emerald-500/20 transition-all duration-300">
                    <div className="bg-emerald-700/50 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                      <card.icon className="w-6 h-6 text-white" />
                    </div>
                    <h2 className="text-2xl font-semibold text-white mb-4">
                      {card.title}
                    </h2>
                    <p className="text-gray-200 leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

     <br></br><br></br>
    
  </div>

  );
};

export default LandingPage;